<script>
    import {onMount} from "svelte";
    import {memberTypes} from "../../mjnUtils";

    let {http, memberDetailsRepository, toastr, goTo, id, prefill} = $props();

    let member = $state(null);
    let originalMember = $state(null);

    onMount(() => {
        if (id == -1) {
            member = prefill ? {...prefill} : {};
            originalMember = {};
        } else {
            memberDetailsRepository.by(id).then((fetchedMember) => {
                member = {...fetchedMember};
                originalMember = {...fetchedMember};
            })
        }
    });

    function save() {
        if (id == -1) {
            http.post("/api/czlonek.php", member).then(
                (response) => {
                    if (response.data.status == 200) {
                        toastr.info(
                            "Dodano rekord osoby " + member.imie + " " + member.nazwisko,
                        );
                        const inserted = response.data.records[0];
                        goTo("member-detail", {id: inserted.idcz});
                    } else {
                        toastr.error("Błąd: " + response.data.message);
                    }
                },
                () => {
                    toastr.error("Błąd połączenia");
                },
            );
        } else {
            http.put("/api/czlonek.php", member).then(
                (response) => {
                    if (response.data.status == 200) {
                        toastr.info(
                            "Zmodyfikowano rekord osoby " +
                            member.imie +
                            " " +
                            member.nazwisko,
                        );
                        goTo("member-detail", {id: member.idcz});
                    } else {
                        toastr.error("Błąd: " + response.data.message);
                    }
                },
                () => {
                    toastr.error("Błąd połączenia");
                },
            );
        }
    }

    function reset() {
        member = {...originalMember};
    }
</script>

{#if member}
    <h3>Edycja: {member.imie} {member.nazwisko}</h3>

    <form class="form form-grid" onsubmit={(e) => { e.preventDefault(); save(); }}>
        <div class="form-group">
            <label for="imie">Imie:</label>
            <input type="text" class="form-control input-sm" placeholder="Imię" bind:value={member.imie} id="imie"
                   size="20" required>&nbsp;
        </div>
        <div class="form-group">
            <label for="nazwisko">Nazwisko</label>
            <input type="text" class="form-control input-sm" placeholder="Nazwisko" bind:value={member.nazwisko}
                   id="nazwisko" size="24" required>
        </div>
        <div class="form-group">
            <label for="typ">Status członkostwa</label>
            <select class="form-control input-sm" name="typ" bind:value={member.typ} required>
                <option value="">-- wybierz --</option>
                {#each memberTypes as option}
                    <option value={option.idx}>{option.name}</option>
                {/each}
            </select>
        </div>
        {#if member.typ !== originalMember.typ}
        <div class="form-group">
            <label for="nruchwaly">Nr uchwały zmieniającej status</label>
            <input type="text" class="form-control input-sm" placeholder="Numer uchwały"
                   bind:value={member.nr_uchwaly} id="nruchwaly" size="50">
        </div>
        <div class="form-group">
            <label for="data_uchwaly">Data uchwały zmieniającej status</label>
            <input type="text" class="form-control input-sm" placeholder="Data uchwały"
                   bind:value={member.data_uchwaly} id="data_uchwaly" size="50">
        </div>
        {/if}
        <div class="form-group">
            <label for="data_urodzenia">Data urodzenia</label>
            <input type="text" class="form-control input-sm" placeholder="Data urodzenia"
                   bind:value={member.data_urodzenia} id="data_urodzenia" size="50">
        </div>
        <div class="form-group">
            <label for="dzielnica">Dzielnica:</label>
            <input type="text" list="dzielnice" class="form-control input-sm" placeholder="Dzielnica"
                   bind:value={member.dzielnica} id="dzielnica" size="50">
            <datalist id="dzielnice">
                <option value="Śródmieście"></option>
                <option value="Żoliborz"></option>
                <option value="Mokotów"></option>
                <option value="Praga Południe"></option>
                <option value="Praga Północ"></option>
                <option value="Ursynów"></option>
                <option value="Bemowo"></option>
                <option value="Białołęka"></option>
                <option value="Bielany"></option>
                <option value="Ochota"></option>
                <option value="Rembertów"></option>
                <option value="Targówek"></option>
                <option value="Ursus"></option>
                <option value="Wawer"></option>

                <option value="Wesoła"></option>
                <option value="Wilanów"></option>
                <option value="Włochy"></option>
                <option value="Wola"></option>
            </datalist>
        </div>
        <div class="form-group">
            <label for="kod_pocztowy">Kod pocztowy</label>
            <input type="text" class="form-control input-sm" placeholder="00-000" bind:value={member.kod_pocztowy}
                   id="kod_pocztowy" size="6">
        </div>
        <div class="form-group">
            <label for="email">Adres e-mail</label>
            <input type="text" class="form-control input-sm" placeholder="Email" bind:value={member.email}
                   id="email" size="50">
        </div>
        <div class="form-group">
            <label for="email_mjn">Adres e-mail MJN</label>
            <input type="text" class="form-control input-sm" placeholder="Email MJN" bind:value={member.email_mjn}
                   id="email_mjn" size="50">
        </div>
        <div class="form-group">
            <label for="email_slack">Adres e-mail Slack</label>
            <input type="text" class="form-control input-sm" placeholder="Email Slack"
                   bind:value={member.email_slack} id="email_slack" size="50">
        </div>
        <div class="form-group">
            <label for="nrtel">Numer telefonu</label>
            <input type="text" class="form-control input-sm" placeholder="Numer telefonu" bind:value={member.nrtel}
                   id="nrtel" size="50">
        </div>
        <div class="form-group">
            <label for="nruchwaly">Nr uchwały przyjmującej</label>
            <input type="text" class="form-control input-sm" placeholder="Numer uchwały"
                   bind:value={member.nr_uchwaly} id="nruchwaly" size="50">
        </div>
        <div class="form-group">
            <label for="data_uchwaly">Data uchwały przyjmującej</label>
            <input type="text" class="form-control input-sm" placeholder="Data uchwały"
                   bind:value={member.data_uchwaly} id="data_uchwaly" size="50" required>
        </div>
        <div class="form-group">
            <label for="data_odejscia">Data odejścia</label>
            <input type="text" class="form-control input-sm" placeholder="Data odejścia"
                   bind:value={member.data_odejscia} id="data_odejscia" size="50">
        </div>
        <div class="form-group">
            <label for="nastepny_kontakt">Następny kontakt (windykacja)</label>
            <input type="text" class="form-control input-sm" placeholder="Nastepny kontakt"
                   bind:value={member.nastepny_kontakt} id="nastepny_kontakt" size="50">
        </div>
        <div class="form-group">
            <label for="notka">
                Notatki:
            </label>
            <textarea class="form-control input-sm" name="notka" id="notka" bind:value={member.notka} rows="8"
                      cols="50"></textarea>
        </div>
      <div class="form-actions">
        <button class="btn btn-info" type="submit">Zapisz</button>
        <button class="btn btn-info" type="button" onclick={reset}>Przywróć początkowe</button>
      </div>
    </form>
{/if}
